export default __webpack_public_path__ + "4bcf4835f989e62c62e0a5afee811cd3.svg";